import { useState, Fragment, lazy } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";

import * as S from "./styles";

const SvgIcon = lazy(() => import("../../common/SvgIcon"));
const Button = lazy(() => import("../../common/Button"));

const Header = ({ t }) => {
  const [visible, setVisibility] = useState(false);

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const navigateTo = (path) => {
      window.location.href = path;
      setVisibility(false);
    };
    return (
      <Fragment>
        <S.CustomNavLinkSmall onClick={() => navigateTo("/")}>
          <S.Span>{t("Games")}</S.Span>
        </S.CustomNavLinkSmall>
        <S.CustomNavLinkSmall onClick={() => navigateTo("/minigames")}>
          <S.Span>{t("Mini Games")}</S.Span>
        </S.CustomNavLinkSmall>
        <S.CustomNavLinkSmall onClick={() => navigateTo("/wip")}>
          <S.Span>{t("Work in Progress")}</S.Span>
        </S.CustomNavLinkSmall>
        <S.CustomNavLinkSmall onClick={() => navigateTo("/archive")}>
          <S.Span>{t("Archive")}</S.Span>
        </S.CustomNavLinkSmall>
      </Fragment>
    );
  };

  return (
    <S.Header>
      <S.Container>
        <S.HeaderContent>
          <S.LogoContainer to="/" aria-label="homepage">
            <img src="/img/icons/logo.png" alt="LittleMyles" height="70px"/>
          </S.LogoContainer>
          <S.NotHidden>
            <MenuItem />
          </S.NotHidden>
          <S.Burger onClick={showDrawer}>
            <S.Outline />
          </S.Burger>
        </S.HeaderContent>
        <Drawer closable={false} open={visible} onClose={onClose}>
            <Col style={{ marginBottom: "2.5rem" }}>
              <S.Label onClick={onClose}>
                <Col span={12}>
                  <S.Menu>Menu</S.Menu>
                </Col>
                <Col span={12}>
                  <S.Outline padding="true" />
                </Col>
              </S.Label>
            </Col>
            <MenuItem />
        </Drawer>
      </S.Container>
    </S.Header>
  );
};

export default withTranslation()(Header);
